/**
 * Generated runtime TestId mirror for frontend/src/pages/admin/RehireReviewDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RehireReviewDetailTestIds = {
  badgeDecidedByConnector: "badge-decided-by-connector",
  btnCancel: "btn-cancel",
  btnCreateAccessRequests: "btn-create-access-requests",
  btnCreateNew: "btn-create-new",
  btnReject: "btn-reject",
  btnResurrect: "btn-resurrect",
  btnSubmit: "btn-submit",
  cardTitlePreviousAccess: "card-title-previous-access",
  cardTitleRehireReviewDiff: "card-title-rehire-review-diff",
  colAttribute: "col-attribute",
  colNewValue: "col-new-value",
  colOldValue: "col-old-value",
  decisionInfoDecidedBy: "decision-info-decided-by",
  entryDateError: "entry-date-error",
  inputNewEntryDate: "input-new-entry-date",
  inputReason: "input-reason",
  previousAccessSelectionCount: "previous-access-selection-count",
  reasonError: "reason-error",
  rehireReviewActionBar: "rehire-review-action-bar",
  rehireReviewDecisionDialog: "rehire-review-decision-dialog",
  rehireReviewDecisionInfo: "rehire-review-decision-info",
  rehireReviewDetail: "rehire-review-detail",
  rehireReviewDiffCard: "rehire-review-diff-card",
  rehireReviewIncomingCard: "rehire-review-incoming-card",
  rehireReviewMatchedCard: "rehire-review-matched-card",
  rehireReviewPreviousAccessCard: "rehire-review-previous-access-card",
  rehireReviewReadonly: "rehire-review-readonly",
  toastOpenIdentity: "toast-open-identity",
  toastOpenMyRequests: "toast-open-my-requests",
  toastOpenNewIdentity: "toast-open-new-identity",
  diffRow: (row_attribute: string) => `diff-row-${row_attribute}`,
  diffRowPrefix: () => "diff-row-" as TestIdPrefix
} as const;
